import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultPUR1030_R01DetailDto, defaultPUR1030_R01HeaderDto, PUR1030_R01DetailDto, PUR1030_R01HeaderDto } from './Dto_PUR1030_R01';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface PUR1030_R01Filter {
	
	dateRange: DateRange | undefined;
	purchaseOrderNo: string;
	customCd: string;
	customNm: string;
	orderStatus: string;
}
export interface Store_PUR1030_R01 {
	PUR1030_R01Filter: PUR1030_R01Filter;
	PUR1030_R01PastFilter: PUR1030_R01Filter;
	setPUR1030_R01Filter: (filter: Partial<Store_PUR1030_R01['PUR1030_R01Filter']>) => void;
	setPUR1030_R01PastFilter: (filter: Store_PUR1030_R01['PUR1030_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	PUR1030_R01List: PUR1030_R01HeaderDto[];
	setPUR1030_R01List: (dataList: PUR1030_R01HeaderDto[]) => void;

	editPUR1030_R01: PUR1030_R01HeaderDto | null;
	setEditPUR1030_R01: (editSale: PUR1030_R01HeaderDto | null) => void;

	selectedPUR1030_R01: PUR1030_R01HeaderDto | undefined;
	setSelectedPUR1030_R01: (data: PUR1030_R01HeaderDto | undefined) => void;
	initSelectedPUR1030_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR1030_R01DetailList: string[];
	setDeletedPUR1030_R01DetailList: (idList: string[]) => void;
	addDeletedPUR1030_R01DetailList: (idList: string[]) => void;
	removeDeletedPUR1030_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	PUR1030_R01DetailList: PUR1030_R01DetailDto[];
	setPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[]) => void;
	insertPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[], index?: number) => void;
	removePUR1030_R01DetailList: (index: number) => void;
	updatePUR1030_R01DetailList: (index: number, data: PUR1030_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedPUR1030_R01DetailList: string[];
	setSelectedPUR1030_R01DetailList: (idList: string[]) => void;
	addSelectedPUR1030_R01DetailList: (idList: string[]) => void;
	removeSelectedPUR1030_R01DetailList: (idList?: string[]) => void;
	initSelectedPUR1030_R01DetailList: () => void;

	originalPUR1030_R01DetailList: PUR1030_R01DetailDto[];
	setOriginalPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	//출하여부, 출하정보 존재시 수주/발주/입고/출고 정보 수정 불가
	isTransported: boolean;
	setIsTransported: (isTransported: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultPUR1030_R01Filter : PUR1030_R01Filter = {
	
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	purchaseOrderNo: '',
	customCd: '',
	customNm: '',
	orderStatus: 'N'
};

export const usePUR1030_R01Store = create<Store_PUR1030_R01>((set) => ({
	PUR1030_R01Filter: defaultPUR1030_R01Filter,
	PUR1030_R01PastFilter: defaultPUR1030_R01Filter,
	setPUR1030_R01Filter: (update) => set((state) => ({
		PUR1030_R01Filter: {
			...state.PUR1030_R01Filter,
			...update
		}
	})),
	setPUR1030_R01PastFilter: (filter: Store_PUR1030_R01['PUR1030_R01PastFilter']) => set((state) => {
		return {
			...state,
			PUR1030_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	PUR1030_R01List: [],
	setPUR1030_R01List: (dataList: PUR1030_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PUR1030_R01List: dataList
		}
	}),

	editPUR1030_R01: defaultPUR1030_R01HeaderDto,
	setEditPUR1030_R01: (editSale: PUR1030_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editPUR1030_R01: editSale
		}
	}),

	selectedPUR1030_R01: undefined,
	
	setSelectedPUR1030_R01: (data: PUR1030_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedPUR1030_R01: data,
			selectedPUR1030_R01DetailList: [], deletedPUR1030_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedPUR1030_R01: () => set({ selectedPUR1030_R01: undefined, PUR1030_R01DetailList: [], detailFetchTrigger: false }),

	// ====== 매출 상세(디테일) 데이터 ======
	PUR1030_R01DetailList: [],
	setPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[]) => set((state) => {
		let newList: PUR1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPUR1030_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PUR1030_R01DetailList: newList
		}
	}),
	insertPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[], index?: number) => set((state) => {
		let newPUR1030_R01DetailList = [...state.PUR1030_R01DetailList];

		let targetRowData = newPUR1030_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newPUR1030_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPUR1030_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPUR1030_R01DetailList = newPUR1030_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newPUR1030_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPUR1030_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		// console.log('newData : ', newData);
		if (index !== undefined) {
			newPUR1030_R01DetailList.splice(index, 0, ...newData);
		} else {
			newPUR1030_R01DetailList.push(...newData);
		}

		return {
			...state,
			PUR1030_R01DetailList: newPUR1030_R01DetailList
		}
	}),
	removePUR1030_R01DetailList: (index: number) => set((state) => {
		const newPUR1030_R01DetailList = [...state.PUR1030_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PUR1030_R01DetailList: newPUR1030_R01DetailList
		}
	}),
	updatePUR1030_R01DetailList: (valueIndex: number, data: PUR1030_R01DetailDto) => set((state) => {
		const _PUR1030_R01DetailList = state.PUR1030_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.orderQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.orderQty = 0;
		}
		return {
			...state,
			PUR1030_R01DetailList: _PUR1030_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR1030_R01DetailList: [],
	setDeletedPUR1030_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPUR1030_R01DetailList: idList
		}
	}),
	addDeletedPUR1030_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedPUR1030_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.PUR1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PUR1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPUR1030_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedPUR1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPUR1030_R01DetailList: [...state.deletedPUR1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPUR1030_R01DetailList: [],
	setSelectedPUR1030_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPUR1030_R01DetailList: idList
		}
	}),
	addSelectedPUR1030_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedPUR1030_R01DetailList = [...state.selectedPUR1030_R01DetailList];
		if(idList.length > 0) {
			_selectedPUR1030_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedPUR1030_R01DetailList: _selectedPUR1030_R01DetailList
		}
	}),
	removeSelectedPUR1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPUR1030_R01DetailList: [...state.selectedPUR1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPUR1030_R01DetailList: () => set({ selectedPUR1030_R01DetailList: [] }),

	originalPUR1030_R01DetailList: [],
	setOriginalPUR1030_R01DetailList: (data: PUR1030_R01DetailDto[]) => set((state) => {
		let newList: PUR1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPUR1030_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPUR1030_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,				setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	isTransported: false,
	setIsTransported: (isTransported: boolean) => set({ isTransported }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		PUR1030_R01Filter: defaultPUR1030_R01Filter,
		PUR1030_R01PastFilter: defaultPUR1030_R01Filter,
		PUR1030_R01List: [],
		selectedPUR1030_R01: undefined,
		PUR1030_R01DetailList: [],
		deletedPUR1030_R01DetailList: [],
		selectedPUR1030_R01DetailList: [],
		editPUR1030_R01: defaultPUR1030_R01HeaderDto,
		allCount: 0,

		isTransported: false,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
